export const data =
{
    scene: '01_epilogi',
    teksti: 'Kerrot Pentille, että tarkoituksena on pistää insuliini sekä varmistaa, että Pentti osaa käyttää liikkumisen apuvälineitä, jotka hän on saanut apv-lainaamosta. (Katso tarkemmat tiedot klikkaamalla alareunan nappia).  Pentti on hyvillään ja kutsuu teidät peremmälle.'





};



